import { Container, Row, Col } from "react-bootstrap";
import { useLandingConfig } from "../../context/OpenDoorEventContext";

const Slider = () => {
  const { banners } = useLandingConfig();

  return (
    <Container fluid className="p-0 m-0 mx-auto banner-ranger">
      <Row className="p-0 m-0">
        <Col md={12} className="mx-auto p-0 m-0">
          <a href="#formulario-inscripcion" className="banner-ranger__link">
            <img
              className="d-block img-fluid w-100 d-md-none"
              src={banners.mobile}
              alt="Ranger Test Drive Day"
            />
            <img
              className="d-none d-md-block img-fluid w-100"
              src={banners.desktop}
              alt="Ranger Test Drive Day"
            />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default Slider;
